import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';
import {getEventNameByPromptType} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import {amplitude} from '@/services/analytics/amplitude/index';

const trackEnableNotificationScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.ENABLE_NOTIFICATION);
};

const trackEnableNotificationScreenNextButton = () => {
    amplitude.trackWithSource(amplitudeEventNames.NEXT_BUTTON_CLICKED);
};

const trackSubscribeToReceiveMessages = () => {
    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATION_ALLOWED, {
        [analyticsEventProperties.SUCCESS]: true,
    });
};

const trackUnsubscribeToReceiveMessages = () => {
    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATION_ALLOWED, {
        [analyticsEventProperties.SUCCESS]: false,
    });
};

const trackPushNotificationsSettingScreenViewed = (isEnabled) => {
    const settingValue = isEnabled ? 'Enabled' : 'Disabled';

    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATIONS_SETTINGS_SCREEN_VIEWED, {
        [analyticsEventProperties.GLOBAL_SETTING_VALUE]: settingValue,
    });
};

const trackPushNotificationsSettingChanged = (isEnabled, isSuccess) => {
    const settingValue = isEnabled ? 'Enabled' : 'Disabled';

    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATIONS_SETTINGS_CHANGED, {
        [analyticsEventProperties.GLOBAL_SETTING_VALUE]: settingValue,
        [analyticsEventProperties.SUCCESS]: isSuccess,
    });
};

const trackPushNotificationsPromptViewed = (promptType) => {
    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATIONS_PROMPT_VIEWED, {
        [analyticsEventProperties.TRIGGER]: getEventNameByPromptType(promptType),
    });
};

const trackPushNotificationsSystemSettingsStepsViewed = () => {
    amplitude.trackWithSource(amplitudeEventNames.NOTIFICATIONS_SYSTEM_SETTINGS_STEPS_VIEWED);
};

export default {
    trackEnableNotificationScreen,
    trackEnableNotificationScreenNextButton,
    trackSubscribeToReceiveMessages,
    trackUnsubscribeToReceiveMessages,
    trackPushNotificationsSettingScreenViewed,
    trackPushNotificationsSettingChanged,
    trackPushNotificationsPromptViewed,
    trackPushNotificationsSystemSettingsStepsViewed,
};
